import React, { useRef } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import NotificationsIcon from '@material-ui/icons/Notifications'
import {
  SERVICES_URL,
  useDisclosure,
  useLocale,
  useTranslation
} from '@plandi/common'
import Menu from '@material-ui/core/Menu'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'

import { useNotificationIconStyles } from './notification-icon.styles'
import {
  NotificationTabContent,
  useQueryCountNewNotifications
} from '../common'

type NotificationIconProps = {
  notificationUrl?: string
}

export const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const classes = useNotificationIconStyles()
  const notificationIconRef = useRef<HTMLButtonElement | null>(null)
  const { data: translate } = useTranslation()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const url = SERVICES_URL
  const locale = useLocale()

  const { data: countNewNotification, isLoading } =
    useQueryCountNewNotifications({
      select: (data) =>
        (
          Object.keys(data.count ?? {}) as Array<keyof typeof data.count>
        ).reduce((acc, key) => acc + (data?.count?.[key] ?? 0), 0)
    })

  const hasCountNoficiations = (countNewNotification ?? 0) > 0

  const notificationsUrl =
    props.notificationUrl ??
    (locale === 'ru'
      ? `${url.main}/ru` + '/notifications'
      : url.main + '/notifications')

  return (
    <>
      <IconButton
        style={{
          padding: 0,
          width: 32,
          height: 32,
          color: '#000'
        }}
        color="default"
        onClick={onOpen}
        ref={notificationIconRef}
      >
        <Badge
          color="secondary"
          invisible={isLoading || !hasCountNoficiations}
          variant="dot"
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
      {isOpen && (
        <Menu
          open={isOpen}
          onClose={onClose}
          className={classes.menu}
          anchorEl={notificationIconRef.current}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          classes={{ list: classes.list }}
        >
          <Paper className={classes.paper}>
            <NotificationTabContent
              emptyMenuClass={classes.emptyMenu}
              tabPanelClassName={classes.tabPanel}
              withoutRead
              className="tabContainer"
            />
            <div className={classes.bottomNav}>
              <Button href={notificationsUrl} fullWidth color="primary">
                {translate?.notifications['all-notifications']}
              </Button>
            </div>
          </Paper>
        </Menu>
      )}
    </>
  )
}
